import { createContext } from 'react';
// eslint-disable-next-line max-len
import { EndorsementServiceFeaturesGetCertificateAuthoritiesAvailableCertificateAuthoritiesDto as AuthoritiesDto } from '@sdir/httpclient/lib/clients/aps/endorsement';
import { Loadable } from '../../types';

export const AuthoritiesContext = createContext<Loadable<AuthoritiesDto[]>>({
  loading: false,
  result: null,
  error: null,
});
